export default __webpack_public_path__ + "static/media/Group-933.e81a54bf.svg";